import styled from 'styled-components';
import { COLORS } from '../../Styles/Colors';

const IconWrapper = styled.div<{ active?: boolean }>`
  display: flex;
  align-items: center;
  padding: 12px 20px;
  margin-bottom: 8px;
  border-radius: 8px;
  background-color: ${props => (props.active ? COLORS.teal : 'transparent')};
  cursor: pointer;
  transition: background-color 0.25s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background-color: ${props => (props.active ? COLORS.teal : `${COLORS.teal}cc`)};
  }

  & svg {
    width: 24px;
    height: 24px;
    margin-right: 12px;
    fill: ${props => (props.active ? COLORS.white : 'white')};
  }

  span {
    color: white;
    font-size: 15px;
    font-weight: 500;
  }

  @media (max-width: 899px) {
    padding: 14px 16px;
    min-height: 48px;
  }
`;

export default IconWrapper;
